import React from 'react';
import { QUIZ_CONSTANTS } from '../lib/constants';
import PopoverContainer from './PopoverContainer';
import PropTypes from 'prop-types';
import FeedComplete from './FeedComplete';
import { get, extend } from 'lodash';
import FeedbackContent from './FeedbackContent';

class Feedback extends React.Component {
  constructor() {
    super();
    this.state = {
      feedbackNoTextError: false,
      feedbackSelectionType: '',
      showFinalText: false
    };
  }

  feedbackSelected = feedbackSelectionType => {
    this.setState({ feedbackSelectionType, feedbackNoTextError: false });
    this.fptiFeedbackClick({ link: feedbackSelectionType });
  };

  undoNoTextError = () => this.setState({ feedbackNoTextError: false });

  closePopover = options => {
    const { type } = options,
      nextState = { feedbackSelectionType: '', feedbackNoTextError: false };
    //If the click isn't detected outside the popover, close the popover and fire fpti for close link
    if (type !== 'outside') {
      extend(nextState, { showFinalText: true });
      this.fptiFeedbackClick({ link: 'close' });
    }
    //If the click is outside the popover hide the popover
    this.setState(nextState);
  };

  submitPopOver = feedbackTextVal => {
    //If the text area length is zero show error else submit
    if (feedbackTextVal.length === 0) {
      this.setState({ feedbackNoTextError: true });
    } else {
      this.fptiFeedbackClick({ link: 'submit', feedbackTextVal });
      this.setState({ showFinalText: true });
    }
  };

  fptiFeedbackClick(options) {
    const { link, feedbackTextVal } = options,
      { location, fptiHelper } = this.props,
      fptiOptions = {
        page: 'main:businessweb:mep:dashboard:main:quiz:results:feedback',
        link,
        survey_name: 'activation_quiz_feedback',
        entry_point: get(location, 'search', '').includes('appcenter=true')
      };

    if (feedbackTextVal)
      extend(fptiOptions, {
        survey_data: {
          question1: QUIZ_CONSTANTS.feedback.feedbackTitle,
          FeedbackText: feedbackTextVal
        }
      });
    fptiHelper.fptiClick(fptiOptions);
  }

  render() {
    const {
      feedbackSelectionType,
      showFinalText,
      feedbackNoTextError
    } = this.state;
    return (
      <React.Fragment>
        {showFinalText ? (
          <FeedComplete />
        ) : (
          <React.Fragment>
            <FeedbackContent
              feedbackSelected={this.feedbackSelected}
              feedbackSelectionType={feedbackSelectionType}
            />
            <PopoverContainer
              feedbackSelectionType={feedbackSelectionType}
              submitPopOver={this.submitPopOver}
              closePopover={this.closePopover}
              feedbackNoTextError={feedbackNoTextError}
              undoNoTextError={this.undoNoTextError}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

Feedback.propTypes = {
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};

export default Feedback;
